var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningiconweb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_warning_icon",
    "data-name": " warning icon",
    transform: "translate(-80 -1090)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27462",
    "data-name": "Path 27462",
    d: "M40,0A40,40,0,1,1,0,40,40,40,0,0,1,40,0Z",
    transform: "translate(80 1090)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9715",
    "data-name": "Group 9715",
    transform: "translate(-126.563 -90.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27726",
    "data-name": "Path 27726",
    d: "M31.141,0A31.141,31.141,0,1,1,0,31.141,31.141,31.141,0,0,1,31.141,0Z",
    transform: "translate(215.563 1189.563)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-exclamation-circle",
    "data-name": "Icon awesome-exclamation-circle",
    d: "M64.563,32.563a32,32,0,1,1-32-32A32,32,0,0,1,64.563,32.563Zm-32,6.452A5.935,5.935,0,1,0,38.5,44.95,5.936,5.936,0,0,0,32.563,39.014ZM26.927,17.679l.957,17.548a1.548,1.548,0,0,0,1.546,1.464h6.264a1.548,1.548,0,0,0,1.546-1.464L38.2,17.679a1.548,1.548,0,0,0-1.546-1.633H28.473A1.548,1.548,0,0,0,26.927,17.679Z",
    transform: "translate(214 1188)",
    fill: "#991f1f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningiconweb);
export default __webpack_public_path__ + "static/media/warning icon web.dbf447848bb84755b400157b488fb56d.svg";
export { ForwardRef as ReactComponent };